import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-180dddb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-subtitle level-bg d-flex flex-justify-center flex-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "tabs-team d-flex flex-items-center py-3 px-2 px-sm-3"
}
const _hoisted_3 = { class: "mr-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dots-vertical d-none d-sm-block" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "tabs-team d-flex flex-items-center py-3 px-2 px-sm-3"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "ml-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.team1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.team1.name), 1),
          (_ctx.team1.avatar !== null)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "img-circle img-50",
                src: _ctx.team1.avatar.url
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    (_ctx.team2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.team2.avatar !== null)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "img-circle img-50",
                src: _ctx.team2.avatar.url
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true),
          _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.team2.name), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}